import { Box, Button, ButtonGroup, Center, Container, Flex, HStack, Heading, Stack, Text } from '@chakra-ui/react';
import IconPencil from 'assets/icons/icon-pencil.svg?react';
import IconSendPlane from 'assets/icons/icon-send-plane.svg?react';
import ButtonEmailPreview from 'components/ButtonEmailPreview';
import BoxDivider from 'components/ui/BoxDivider';
import ButtonBack from 'components/ui/ButtonBack';
import FixedBar from 'components/ui/FixedBar';
import InfoList from 'components/ui/InfoList';
import PeriodTime from 'components/ui/PeriodTime';
import { LinkAgendaPreview } from 'features/emails/config';
import { useMessages } from 'hooks/useMessages';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageContent from '../../../components/PageContent';
import { useSendAgenda } from '../hooks/useSendAgenda';
import { useSendAgendaTestEmail } from '../hooks/useSendAgendaTestEmail';

export default function FormCheckData({ agenda }: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const { onError, onSuccess } = useMessages({ success: 'E-mail enviado com sucesso!'});
  
  const { onSendTestEmail, isPending } = useSendAgendaTestEmail({ 
    agendaId: agenda.id,
    onError, 
    onSuccess
  });

  const { onSendAgenda, isPending: isPendingSendContent } = useSendAgenda({ 
    agendaId: agenda.id,
    onSuccess: () => navigate(`/disparos-de-agenda${location.search}`)
  });

  return (
    <>
      <Box 
        w="full"
        pos="relative"
      >
        <BoxDivider />

        <Container
          variant="internal"
          flexDirection="column" 
        >
          <Flex 
            flex={1} 
            justifyContent="space-between"
          >
            <Heading as="h1" size="h1">
              Conferir dados
              <span>Veja a prévia do e-mail e valide os dados com atenção</span>
            </Heading>

            <Button
              leftIcon={<IconPencil />}
              as={Link}
              to={{
                pathname: `/disparos-de-agenda/editar/${agenda.id}`,
                search: location.search,
              }}
            >
              Voltar para edição
            </Button>
          </Flex>
        </Container>
      </Box>

      <Container
        variant="internal"
        flexDirection="column" 
        mb="80px"
      >
        <InfoList>
          <Box>
            <Text as="span">
              <small>Modelo</small>
              {agenda.contentGroup.name}
            </Text>
          </Box>
          <Box>
            <Text as="span">
              <small>Lista</small>
              {`${agenda.list.company.name} - ${agenda.list.name}`}
            </Text>
          </Box>
          <Box>
            <Text as="span">
              <small>Assunto do e-mail</small>
              {`${agenda.title}`}
            </Text>
          </Box>
          <Box>
            <Text as="span">
              <small>Período referência das notas</small>
              <PeriodTime 
                startsAt={agenda.startsAt} 
                endsAt={agenda.endsAt} 
                noBreakLine
              />
            </Text>
          </Box>
        </InfoList>

        <Box 
          bgColor="rgba(226, 228, 233, 0.50)"
          mt="65px"
        >
          <Stack
            bgColor="#20232D"
            padding="28px 23px"
            borderTopRadius="15px"
            color="white"
            direction="row"
            justifyContent="space-between"
          >
            <Box>
              <Text opacity={0.8}>{`De: Patri <patri@patri.com.br>`}</Text>
              <Text fontWeight="semibold">Para: {`${agenda.list.company.name} - ${agenda.list.name}`}</Text>
            </Box>
            <ButtonEmailPreview url={LinkAgendaPreview(agenda)} />
          </Stack>
          
          <Center pb="30px">
            <PageContent url={LinkAgendaPreview(agenda)} />
          </Center>
        </Box>
      </Container>

      <FixedBar>
        <ButtonBack 
          as={Link}
          to={{
            pathname: `/disparos-de-agenda/editar/${agenda.id}/notas`,
            search: location.search,
          }}
        />
        
        <HStack spacing="50px">
          
          <ButtonGroup>
            <Button
              bgColor="#F6F8FA"
              border="none"
              color="#525866"
              fontWeight="semibold"
              rightIcon={<IconSendPlane />}
              size="sm"
              isLoading={isPending}
              onClick={() => onSendTestEmail()}
            >
              Enviar e-mail de teste
            </Button>

            <Button
              variant="primary"
              rightIcon={<IconSendPlane />}
              onClick={() => onSendAgenda()}
              isLoading={isPendingSendContent}
            >
              Enviar
            </Button>
          </ButtonGroup>
        </HStack>
      </FixedBar>

    </>
  )
}
